import { fromJS } from 'immutable';

// Treat anything with getIn/toJS as Immutable
const toImmutable = (x) =>
  x && typeof x.getIn === 'function' && typeof x.toJS === 'function'
    ? x
    : fromJS(x || {});

/**
 * Wrap a legacy redux-form/immutable validator so it works with RFF.
 * - valuesJS: plain object from RFF
 * - props.initialValues can be JS or Immutable; we normalize to Immutable
 */
export function makeRffValidateFromLegacy(
  legacyValidate,
  props,
  initialValuesMaybeJS
) {
  const legacyProps = {
    ...props,
    initialValues: toImmutable(initialValuesMaybeJS),
  };

  return function validate(valuesJS) {
    const formImm = toImmutable(valuesJS);
    const errors = legacyValidate(formImm, legacyProps);
    return errors || {};
  };
}
